module.exports = __webpack_public_path__ + "2f685507f31b4008550f78e4bc5c171e.png";